// 按模块的action, reducer整合体
const BACK_INFO = 'BACK_INFO';

export function setBackInfo(params) {
  return dispatch => {
    return dispatch({
      type: BACK_INFO,
      data: params,
    });
  };
}

export function backInfo(state = {}, action) {
  switch (action.type) {
    case BACK_INFO:
      return action.data;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/back_info.js